import { alpha, IconButton, Popover } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import type { Editor } from '@tiptap/react';
import React, { memo } from 'react';

import { borderRadius, boxShadows, palette } from '../../../../../assets/styles/themes/tokens';
import LinkMenu from '../../LinkMenu';

interface ContextLinkMenuProps {
	id: string;
	handleClick: (event: React.MouseEvent<HTMLElement>) => void;
	handleClose: () => void;
	anchorEl: HTMLElement | null;
	editor: Editor;
	icon: JSX.Element;
}

const ContextLinkMenu: React.FC<ContextLinkMenuProps> = (props) => {
	const { id, handleClick, handleClose, anchorEl, editor, icon } = props;
	const isAnchorElOpen = Boolean(anchorEl && document.body.contains(anchorEl));
	const popoverId = isAnchorElOpen ? id : undefined;

	return (
		<>
			<Tooltip title={id} leaveDelay={0} leaveTouchDelay={0}>
				<IconButton
					data-testid={`${id}-button`}
					color="secondary"
					size="small"
					onClick={handleClick}
					sx={{
						'&:hover': {
							backgroundColor: alpha(palette.primary.main, 0.06),
						},
					}}
				>
					{icon}
				</IconButton>
			</Tooltip>
			{isAnchorElOpen && (
				<Popover
					data-testid={id}
					id={popoverId}
					open={isAnchorElOpen}
					anchorEl={anchorEl}
					onClose={handleClose}
					sx={{
						zIndex: 1500,
					}}
					PaperProps={{
						style: {
							zIndex: 1500,
							overflow: 'visible',
							boxShadow: boxShadows.elevation8,
							borderRadius: borderRadius.xs,
						},
					}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<LinkMenu editor={editor} initialShowEdit={true} />
				</Popover>
			)}
		</>
	);
};

export default memo(ContextLinkMenu);
